import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useEffect, useRef, useState } from 'react'
import { ReadExcelFile } from './ReadExcelFileData'
import { MenuComponent } from '../../../../_metronic/assets/ts/components'
import { DynamicTablePublicAccessInput } from '../../../../generated/graphql'
import { DeleteConfirmPopup } from '../../../../utils/DeleteConfirmPopup'
import { set } from 'date-fns'
import Toast, { ToastType } from '../../../../utils/toast'

export const fetchData = async (fileUrl: string) => {
  let myFile
  try {
    const response = await fetch(fileUrl)
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const urlParts = fileUrl.split('/')
    const fileNameWithQuery = urlParts[urlParts.length - 1]
    const originalFileName = fileNameWithQuery.split('?')[0]
    const blob = await response.blob()
    const file = new File([blob], originalFileName || 'downloaded-file.xlsx', {
      type: blob.type,
    })
    myFile = file
  } catch (error) {
    console.error('Error fetching and loading the file:', error)
    Toast('Error fetching and loading the file', ToastType.error)
  }

  if (myFile) {
    try {
      const dynamicData = await ReadExcelFile(myFile)
      return dynamicData
    } catch (error) {
      console.error('Error reading the Excel file:', error)
      Toast('Error reading the Excel file', ToastType.error)
    }
  }
}

export function NameRender(data: any) {
  const fileUrl = data.data.file
  return (
    <>
      <div className='pt-3'>
        <div
          onClick={async () => {
            const data1 = await fetchData(fileUrl)
            return data.data.navigate(
              data1
                ? {
                    ...data.data.selectedData,
                    tableData: { data: data1[0].data, indexData: data1[0] },
                  }
                : data.data.selectedData
            )
          }}
        >
          <p className='fw-bold text-hover-primary cursor-pointer'>{data.data.name}</p>
        </div>
      </div>
    </>
  )
}

export function UploadFileRender(data: any) {
  function handleClick(item: any) {
    window.open(item.file)
  }
  const fileName = data.data.fileName.split('/')
  return (
    <div className=''>
      <div
        className='d-flex align-items-center'
        onClick={() => {
          data.data.file !== '' && handleClick(data.data)
        }}
      >
        <div className='symbol symbol-35px me-5' style={{ cursor: 'pointer' }}>
          {data.data.file !== '' && (
            <img src={toAbsoluteUrl('/media/svg/files/excel.svg')} alt='' />
          )}
        </div>
        <span className='text-wrap fs-base cursor-pointer'>
          <p
            className='text-truncate mb-0'
            data-toggle='tooltip'
            data-placement='top'
            title={fileName[fileName.length - 1]}
            style={{ maxWidth: '220px' }}
          >
            {fileName[fileName.length - 1]}
          </p>
        </span>
      </div>
    </div>
  )
}

export function FileSizeRender(data: any) {
  return (
    <p className='d-block fs-base pt-2'>
      {data.data.size
        ? data.data > 1000000
          ? (data.data / 1048576).toFixed(2) + ' MB'
          : (data.data / 1024).toFixed(2) + ' KB'
        : '-'}
    </p>
  )
}

export function DeleteActionRender(data: any) {
  const deleteBtnRef = useRef<HTMLButtonElement | null>(null)
  return (
    <div className='px-0'>
      <button
        ref={deleteBtnRef}
        className='btn align-center btn-icon btn-sm btn-secondary'
        onClick={(e) => {
          data.data.handleRemove(e, data.data.id)
        }}
      >
        <KTSVG
          path='media/icons/duotune/general/gen027.svg'
          className='svg-icon-2x   text-primary'
        />
      </button>
    </div>
  )
}

export function ActionRender(data: any) {
  const deleteBtnRef = useRef<HTMLButtonElement | null>(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showUnPublish, setShowUnPublish] = useState(false)
  const [deleteLoader, setDeleteLoader] = useState(false)
  const [publishLoader, setPublishLoader] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 50)
  }, [data])

  useEffect(() => {
    setDeleteLoader(data.data.loaders?.isDeleteLoader)
    setPublishLoader(data.data.loaders?.isPublishLoader)
  }, [data.data.loaders?.isDeleteLoader, data.data.loaders?.isPublishLoader])

  const datasetOptions = ['Delete']
  if (data.data.isSuperAdmin && !data.data.isPublished) {
    datasetOptions.push('Publish')
  }

  if (data.data.isPublished) {
    datasetOptions.push('Remove from Published')
  }

  function PublishData() {
    const publishData: DynamicTablePublicAccessInput = {
      id: data.data.id ? Number(data.data.id) : undefined,
      isPublic: true,
    }
    if (data.data.publishTable) data.data.publishTable(publishData)
  }

  function RemovePublishedData() {
    const publishData: DynamicTablePublicAccessInput = {
      id: data.data.id ? Number(data.data.id) : undefined,
      isPublic: false,
    }
    if (data.data.publishTable) {
      setPublishLoader(true)
      data.data.publishTable(publishData)
    }
  }

  const actionMenu = () => {
    let newOptions = datasetOptions
    return newOptions.map((option) => {
      return (
        <label
          key={option}
          className='form-check-custom py-3 bg-hover-primary text-hover-white'
          onClick={(e) => {
            if (option === 'Delete') {
              setShowDeleteModal(true)
            } else if (option === 'Publish') {
              PublishData()
            } else if (option === 'Remove from Published') {
              setShowUnPublish(true)
            }
          }}
        >
          <span className='form-check-label fs-base ms-6 fw-normal cursor-pointer  '>{option}</span>
        </label>
      )
    })
  }

  return (
    <div className='px-0'>
      <button
        type='button'
        className='btn btn-sm btn-icon btn-color-gray-400 btn-active-secondary'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        data-kt-menu-flip='top-end'
      >
        <KTSVG
          path='/media/icons/duotune/general/gen052.svg'
          className='svg-icon-muted svg-icon-2x'
        />
      </button>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3'
        data-kt-menu='true'
      >
        {actionMenu()}
      </div>
      {showUnPublish && (
        <DeleteConfirmPopup
          showModel={showUnPublish}
          setShowModel={setShowUnPublish}
          loading={publishLoader}
          title='Remove from Published'
          description={`Are you sure you want to remove "${data.data.name}" from published tables?`}
          notes='This will remove the table for all users and delete all their custom filters.'
          confirmText={`Type the dataset name "${data.data.name}" to confirm`}
          currentValue={data.data.name || ''}
          primaryButtonText='Remove'
          secondaryButtonText='Cancel'
          primaryAction={() => RemovePublishedData()}
        />
      )}
      {showDeleteModal && (
        <DeleteConfirmPopup
          showModel={showDeleteModal}
          setShowModel={(show) => {
            setShowDeleteModal(show)
            if (!show) {
              setDeleteLoader(false)
            }
          }}
          loading={deleteLoader}
          title='Delete Dataset'
          description={`Are you sure you want to remove this Dataset?`}
          notes='This will delete all custom filters created by other users.'
          confirmText={`Type the dataset name "${data.data.name}" to confirm`}
          currentValue={data.data.name || ''}
          primaryButtonText='Delete'
          secondaryButtonText='Cancel'
          primaryAction={(e: any) => {
            setDeleteLoader(true)
            data.data.handleRemove(e, data.data.id)
          }}
        />
      )}
    </div>
  )
}
